import { Outlet } from "react-router-dom";

export const AuthRoot = () => {
  return <Outlet />;
};

export { LoginPage } from "./Login";
export { LogoutPage } from "./Logout";
export { RegisterPage } from "./Register";
export { VerifyPage } from "./Verify";
export { ResetPasswordPage } from "./ResetPassword";
